import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing a summarized cash flow table view.
 * @extends JetView
 */
export default class tableFlujoCajaResumidoView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var leftSplit = 1; // Variable to determine left split visibility

        // Custom data filter for summing tree column
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable for formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting result based on column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending existing summColumn filter
        );

        // Adjusting leftSplit based on screen width
        webix.ready(function () {
            if (screen.width < 500) {
                leftSplit = 0; // No left split for small screens
            } else {
                leftSplit = 1; // Enable left split for larger screens
            }
        });

        // Conditional rendering based on selected partner
        if (devConfig.getPartnerSelected() == '0') {
            return {
                view: 'treetable', // Using a tree table view
                css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                id: 'CashResume', // Unique ID for the view
                bready: function () {
                    this.openAll(); // Automatically open all rows
                },
                scrollY: true, // Enable vertical scrolling
                columns: [
                    // Column definitions for the tree table
                    {
                        id: 'Fecha',
                        header: _('Fecha'), // Localized header
                        width: 300,
                        template: function (obj, common) {
                            if (obj.$group)
                                return (
                                    common.treetable(obj, common) + obj.value // Grouping template
                                );
                            return obj.Fecha; // Return date value
                        },
                        footer: _('Total:'), // Footer for total
                    },
                    { id: 'UserId', header: _('ID Usuario'), width: 100 }, // User ID column
                    { id: 'Moneda', header: _('Moneda'), width: 70 }, // Currency column
                    {
                        id: 'CantidadTickets',
                        header: _('Cantidad Tickets'), // Tickets count column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.intFormat, // Formatting function
                        width: 125,
                    },
                    {
                        id: 'ValorEntradasEfectivo',
                        header: _('V.Entradas Efectivo'), // Cash entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 135,
                    },
                    {
                        id: 'VoidedPlacedBets',
                        header: _('Apuestas Anuladas'), // Voided bets column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 135,
                    },
                    {
                        id: 'ValorEntradasEfectivoNeto',
                        header: _('V.Entradas Efectivo Neto'), // Net cash entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 135,
                    },
                    {
                        id: 'ValorEntradasBonoTC',
                        header: _('V.Entradas Bono/T.C'), // Bonus/TC entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 140,
                    },
                    {
                        id: 'ValorEntradasTraslados',
                        header: _('V.Entradas Traslados'), // Transfers entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 145,
                    },
                    {
                        id: 'ValorEntradasRecargas',
                        header: _('V.Entradas Recargas'), // Reloads entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 142,
                    },
                    {
                        id: 'Tax',
                        header: _('Impuestos'), // Tax column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 142,
                    },
                    {
                        id: 'ValorSalidasEfectivo',
                        header: _('V.Salidas Efectivo'), // Cash exits value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 125,
                    },
                    {
                        id: 'VoidedPaidBets',
                        header: _('Apuestas Pagadas Anuladas'), // Voided paid bets column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 125,
                    },
                    {
                        id: 'ValorSalidasEfectivoNeto',
                        header: _('V.Salidas Efectivo Neto'), // Net cash exits value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 125,
                    },
                    {
                        id: 'ValorSalidasTraslados',
                        header: _('V.Salidas Traslados'), // Transfers exits value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 135,
                    },
                    {
                        id: 'ValorSalidasNotasRetiro',
                        header: _('V.Salidas N.Retiro'), // Withdrawal notes exits value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 142,
                    },
                    {
                        id: 'Saldo',
                        header: _('Saldo'), // Balance column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 100,
                    },
                ],
                on: {
                    onBeforeLoad: function () {
                        this.showOverlay(
                            // Show loading overlay before data load
                            "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                        );
                    },
                    onAfterLoad: function () {
                        this.hideOverlay(); // Hide loading overlay after data load
                    },
                },
                ready: function () {
                    if (!this.count()) {
                        // Check if there are no data items
                        webix.extend(this, webix.OverlayBox); // Extend with overlay capabilities
                        this.showOverlay(
                            // Show no data overlay
                            "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>',
                        );
                    }
                },
                autowidth: false, // Disable automatic width adjustment
                math: true, // Enable mathematical operations
                loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
                leftSplit: leftSplit, // Set left split visibility
                pager: 'pagerA', // Pager ID for pagination
                // API endpoint for data fetching
                url: devConfig.geturlApi() + 'es/Financial/GetFlujoCajaResumidoMaquina',
            };
        } else if (devConfig.getPartnerSelected() == '1') {
            return {
                view: 'treetable', // Using a tree table view
                css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                id: 'CashResume', // Unique ID for the view
                bready: function () {
                    this.openAll(); // Automatically open all rows
                },
                scrollY: true, // Enable vertical scrolling
                columns: [
                    // Column definitions for the tree table
                    {
                        id: 'Fecha',
                        header: _('Fecha'), // Localized header
                        width: 300,
                        template: function (obj, common) {
                            if (obj.$group)
                                return (
                                    common.treetable(obj, common) + obj.value // Grouping template
                                );
                            return obj.Fecha; // Return date value
                        },
                        footer: _('Total:'), // Footer for total
                    },
                    { id: 'UserId', header: _('ID Usuario'), width: 100 }, // User ID column
                    { id: 'Moneda', header: _('Moneda'), width: 70 }, // Currency column
                    {
                        id: 'CantidadTickets',
                        header: _('Cantidad Tickets'), // Tickets count column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.intFormat, // Formatting function
                        width: 125,
                    },
                    {
                        id: 'ValorEntradasEfectivo',
                        header: _('V.Entradas Efectivo'), // Cash entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 135,
                    },
                    {
                        id: 'VoidedPaidBets',
                        header: _('Apuestas Pagadas Anuladas'), // Voided paid bets column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 125,
                    },
                    {
                        id: 'ValorEntradasEfectivoNeto',
                        header: _('V.Entradas Efectivo Neto'), // Net cash entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 135,
                    },
                    {
                        id: 'ValorEntradasBonoTC',
                        header: _('V.Entradas Bono/T.C'), // Bonus/TC entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 140,
                    },
                    {
                        id: 'ValorEntradasTraslados',
                        header: _('V.Entradas Traslados'), // Transfers entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 145,
                    },
                    {
                        id: 'ValorEntradasRecargas',
                        header: _('V.Entradas Recargas'), // Reloads entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 142,
                    },
                    {
                        id: 'Tax',
                        header: _('Impuestos'), // Tax column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 142,
                    },
                    {
                        id: 'ValorSalidasEfectivo',
                        header: _('V.Salidas Efectivo'), // Cash exits value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 125,
                    },
                    {
                        id: 'VoidedPaidBets',
                        header: _('Apuestas Pagadas Anuladas'), // Voided paid bets column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 125,
                    },
                    {
                        id: 'ValorSalidasEfectivoNeto',
                        header: _('V.Salidas Efectivo Neto'), // Net cash exits value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 125,
                    },
                    {
                        id: 'ValorSalidasTraslados',
                        header: _('V.Salidas Traslados'), // Transfers exits value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 135,
                    },
                    {
                        id: 'ValorSalidasNotasRetiro',
                        header: _('V.Salidas N.Retiro'), // Withdrawal notes exits value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 142,
                    },
                    {
                        id: 'Saldo',
                        header: _('Saldo'), // Balance column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 100,
                    },
                ],
                on: {
                    onBeforeLoad: function () {
                        this.showOverlay(
                            // Show loading overlay before data load
                            "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                        );
                    },
                    onAfterLoad: function () {
                        this.hideOverlay(); // Hide loading overlay after data load
                    },
                },
                ready: function () {
                    if (!this.count()) {
                        // Check if there are no data items
                        webix.extend(this, webix.OverlayBox); // Extend with overlay capabilities
                        this.showOverlay(
                            // Show no data overlay
                            "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>',
                        );
                    }
                },
                autowidth: false, // Disable automatic width adjustment
                math: true, // Enable mathematical operations
                loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
                leftSplit: leftSplit, // Set left split visibility
                pager: 'pagerA', // Pager ID for pagination
                // API endpoint for data fetching
                url: devConfig.geturlApi() + 'es/Financial/GetFlujoCajaResumido',
            };
        } else if (devConfig.getPartnerSelected() == '2') {
            return {
                view: 'treetable', // Using a tree table view
                css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                id: 'CashResume', // Unique ID for the view
                bready: function () {
                    this.openAll(); // Automatically open all rows
                },
                scrollY: true, // Enable vertical scrolling
                columns: [
                    // Column definitions for the tree table
                    {
                        id: 'Fecha',
                        header: _('Fecha'), // Localized header
                        width: 300,
                        template: function (obj, common) {
                            if (obj.$group)
                                return (
                                    common.treetable(obj, common) + obj.value // Grouping template
                                );
                            return obj.Fecha; // Return date value
                        },
                        footer: _('Total:'), // Footer for total
                    },
                    { id: 'UserId', header: _('ID Usuario'), width: 100 }, // User ID column
                    { id: 'Moneda', header: _('Moneda'), width: 70 }, // Currency column
                    {
                        id: 'CantidadTickets',
                        header: _('Cantidad Tickets'), // Tickets count column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.intFormat, // Formatting function
                        width: 125,
                    },
                    {
                        id: 'ValorEntradasEfectivo',
                        header: _('V.Entradas Efectivo'), // Cash entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 135,
                    },
                    {
                        id: 'VoidedPaidBets',
                        header: _('Apuestas Pagadas Anuladas'), // Voided paid bets column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 125,
                    },
                    {
                        id: 'ValorEntradasEfectivoNeto',
                        header: _('V.Entradas Efectivo Neto'), // Net cash entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 135,
                    },
                    {
                        id: 'ValorEntradasBonoTC',
                        header: _('V.Entradas Bono/T.C'), // Bonus/TC entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 140,
                    },
                    {
                        id: 'ValorEntradasTraslados',
                        header: _('V.Entradas Traslados'), // Transfers entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 145,
                    },
                    {
                        id: 'ValorEntradasRecargas',
                        header: _('V.Entradas Recargas'), // Reloads entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 142,
                    },
                    {
                        id: 'Tax',
                        header: _('Impuestos'), // Tax column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 142,
                    },
                    {
                        id: 'ValorSalidasEfectivo',
                        header: _('V.Salidas Efectivo'), // Cash exits value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 125,
                    },
                    {
                        id: 'VoidedPaidBets',
                        header: _('Apuestas Pagadas Anuladas'), // Voided paid bets column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 125,
                    },
                    {
                        id: 'ValorSalidasEfectivoNeto',
                        header: _('V.Salidas Efectivo Neto'), // Net cash exits value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 125,
                    },
                    {
                        id: 'ValorSalidasTraslados',
                        header: _('V.Salidas Traslados'), // Transfers exits value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 135,
                    },
                    {
                        id: 'ValorSalidasNotasRetiro',
                        header: _('V.Salidas N.Retiro'), // Withdrawal notes exits value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 142,
                    },
                    {
                        id: 'Saldo',
                        header: _('Saldo'), // Balance column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 100,
                    },
                ],
                on: {
                    onBeforeLoad: function () {
                        this.showOverlay(
                            // Show loading overlay before data load
                            "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                        );
                    },
                    onAfterLoad: function () {
                        this.hideOverlay(); // Hide loading overlay after data load
                    },
                },
                ready: function () {
                    if (!this.count()) {
                        // Check if there are no data items
                        webix.extend(this, webix.OverlayBox); // Extend with overlay capabilities
                        this.showOverlay(
                            // Show no data overlay
                            "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>',
                        );
                    }
                },
                autowidth: false, // Disable automatic width adjustment
                math: true, // Enable mathematical operations
                loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
                leftSplit: leftSplit, // Set left split visibility
                pager: 'pagerA', // Pager ID for pagination
                // API endpoint for data fetching
                url: devConfig.geturlApi() + 'es/Financial/GetFlujoCajaResumido',
            };
        } else {
            return {
                view: 'treetable', // Using a tree table view
                css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                id: 'CashResume', // Unique ID for the view
                bready: function () {
                    this.openAll(); // Automatically open all rows
                },
                scrollY: true, // Enable vertical scrolling
                columns: [
                    // Column definitions for the tree table
                    {
                        id: 'Fecha',
                        header: _('Fecha'), // Localized header
                        width: 300,
                        template: function (obj, common) {
                            if (obj.$group)
                                return (
                                    common.treetable(obj, common) + obj.value // Grouping template
                                );
                            return obj.Fecha; // Return date value
                        },
                        footer: _('Total:'), // Footer for total
                    },
                    { id: 'UserId', header: _('ID Usuario'), width: 100 }, // User ID column
                    { id: 'Moneda', header: _('Moneda'), width: 70 }, // Currency column
                    {
                        id: 'CantidadTickets',
                        header: _('Cantidad Tickets'), // Tickets count column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.intFormat, // Formatting function
                        width: 125,
                    },
                    {
                        id: 'ValorEntradasEfectivo',
                        header: _('V.Entradas Efectivo'), // Cash entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 135,
                    },
                    {
                        id: 'VoidedPlacedBets',
                        header: _('Apuestas Anuladas'), // Voided bets column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 135,
                    },
                    {
                        id: 'ValorEntradasEfectivoNeto',
                        header: _('V.Entradas Efectivo Neto'), // Net cash entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 135,
                    },
                    {
                        id: 'ValorEntradasBonoTC',
                        header: _('V.Entradas Bono/T.C'), // Bonus/TC entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 140,
                    },
                    {
                        id: 'ValorEntradasTraslados',
                        header: _('V.Entradas Traslados'), // Transfers entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 145,
                    },
                    {
                        id: 'ValorEntradasRecargas',
                        header: _('V.Entradas Recargas'), // Reloads entries value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 142,
                    },
                    {
                        id: 'Tax',
                        header: _('Impuestos'), // Tax column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 142,
                    },
                    {
                        id: 'ValorSalidasEfectivo',
                        header: _('V.Salidas Efectivo'), // Cash exits value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 125,
                    },
                    {
                        id: 'VoidedPaidBets',
                        header: _('Apuestas Pagadas Anuladas'), // Voided paid bets column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 125,
                    },
                    {
                        id: 'ValorSalidasEfectivoNeto',
                        header: _('V.Salidas Efectivo Neto'), // Net cash exits value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 125,
                    },
                    {
                        id: 'ValorSalidasTraslados',
                        header: _('V.Salidas Traslados'), // Transfers exits value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 135,
                    },
                    {
                        id: 'ValorSalidasNotasRetiro',
                        header: _('V.Salidas N.Retiro'), // Withdrawal notes exits value column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 142,
                    },
                    {
                        id: 'Saldo',
                        header: _('Saldo'), // Balance column
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type for this column
                        width: 100,
                    },
                ],
                on: {
                    onBeforeLoad: function () {
                        this.showOverlay(
                            // Show loading overlay before data load
                            "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                        );
                    },
                    onAfterLoad: function () {
                        this.hideOverlay(); // Hide loading overlay after data load
                    },
                },
                ready: function () {
                    if (!this.count()) {
                        // Check if there are no data items
                        webix.extend(this, webix.OverlayBox); // Extend with overlay capabilities
                        this.showOverlay(
                            // Show no data overlay
                            "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>',
                        );
                    }
                },
                autowidth: false, // Disable automatic width adjustment
                math: true, // Enable mathematical operations
                loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
                leftSplit: leftSplit, // Set left split visibility
                pager: 'pagerA', // Pager ID for pagination
                // API endpoint for data fetching
                url: devConfig.geturlApi() + 'es/Financial/GetFlujoCajaResumido',
            };
        }
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        var url = grid.data.url; // URL for data loading
        grid.attachEvent('onAfterLoad', function () {
            $$('CashResume').data.group({
                // Grouping data by 'Punto'
                by: 'Punto',
                map: {
                    Partner: ['Partner'],
                    Punto: ['Punto'],
                    Agent: ['Agent'],
                    CountryId: ['CountryId'],
                    CountryIcon: ['CountryIcon'],
                    Moneda: ['Moneda'],
                    CantidadTickets: ['CantidadTickets', 'sum'],
                    ValorEntradasEfectivo: ['ValorEntradasEfectivo', 'sum'],
                    ValorEntradasEfectivoNeto: ['ValorEntradasEfectivoNeto', 'sum'],
                    ValorEntradasBonoTC: ['ValorEntradasBonoTC', 'sum'],
                    ValorEntradasTraslados: ['ValorEntradasTraslados', 'sum'],
                    ValorEntradasRecargas: ['ValorEntradasRecargas', 'sum'],
                    Tax: ['Tax', 'sum'],
                    ValorSalidasEfectivo: ['ValorSalidasEfectivo', 'sum'],
                    ValorSalidasEfectivoNeto: ['ValorSalidasEfectivoNeto', 'sum'],
                    ValorSalidasTraslados: ['ValorSalidasTraslados', 'sum'],
                    ValorSalidasNotasRetiro: ['ValorSalidasNotasRetiro', 'sum'],
                    VoidedPaidBets: ['VoidedPaidBets', 'sum'],
                    VoidedPlacedBets: ['VoidedPlacedBets', 'sum'],
                    Saldo: ['Saldo', 'sum'],
                },
            });
            $$('CashResume').data.group({
                // Grouping data by 'Agent'
                by: 'Agent',
                map: {
                    Partner: ['Partner'],
                    Agent: ['Agent'],
                    CountryId: ['CountryId'],
                    CountryIcon: ['CountryIcon'],
                    Moneda: ['Moneda'],
                    CantidadTickets: ['CantidadTickets', 'sum'],
                    ValorEntradasEfectivo: ['ValorEntradasEfectivo', 'sum'],
                    ValorEntradasEfectivoNeto: ['ValorEntradasEfectivoNeto', 'sum'],
                    ValorEntradasBonoTC: ['ValorEntradasBonoTC', 'sum'],
                    ValorEntradasTraslados: ['ValorEntradasTraslados', 'sum'],
                    ValorEntradasRecargas: ['ValorEntradasRecargas', 'sum'],
                    Tax: ['Tax', 'sum'],
                    ValorSalidasEfectivo: ['ValorSalidasEfectivo', 'sum'],
                    ValorSalidasEfectivoNeto: ['ValorSalidasEfectivoNeto', 'sum'],
                    ValorSalidasTraslados: ['ValorSalidasTraslados', 'sum'],
                    ValorSalidasNotasRetiro: ['ValorSalidasNotasRetiro', 'sum'],
                    VoidedPaidBets: ['VoidedPaidBets', 'sum'],
                    VoidedPlacedBets: ['VoidedPlacedBets', 'sum'],
                    Saldo: ['Saldo', 'sum'],
                },
            });
            $$('CashResume').data.group({
                // Grouping data by country icon
                by: function (obj) {
                    return "<i class='flags " + obj.CountryIcon + "'></i>" + obj.CountryId;
                },
                map: {
                    Moneda: ['Moneda'],
                    Partner: ['Partner'],
                    CantidadTickets: ['CantidadTickets', 'sum'],
                    ValorEntradasEfectivo: ['ValorEntradasEfectivo', 'sum'],
                    ValorEntradasEfectivoNeto: ['ValorEntradasEfectivoNeto', 'sum'],
                    ValorEntradasBonoTC: ['ValorEntradasBonoTC', 'sum'],
                    ValorEntradasTraslados: ['ValorEntradasTraslados', 'sum'],
                    ValorEntradasRecargas: ['ValorEntradasRecargas', 'sum'],
                    Tax: ['Tax', 'sum'],
                    ValorSalidasEfectivo: ['ValorSalidasEfectivo', 'sum'],
                    ValorSalidasEfectivoNeto: ['ValorSalidasEfectivoNeto', 'sum'],
                    ValorSalidasTraslados: ['ValorSalidasTraslados', 'sum'],
                    ValorSalidasNotasRetiro: ['ValorSalidasNotasRetiro', 'sum'],
                    VoidedPaidBets: ['VoidedPaidBets', 'sum'],
                    VoidedPlacedBets: ['VoidedPlacedBets', 'sum'],
                    Saldo: ['Saldo', 'sum'],
                },
            });
            $$('CashResume').data.group({
                // Grouping data by partner
                by: function (obj) {
                    return (
                        "<i style='background-image:url(" +
                        profile.Partners.filter((item) => {
                            return item.id == obj.Partner;
                        })[0].image +
                        ") !important;' class='partner " +
                        obj.Partner +
                        "'></i>"
                    );
                },
                map: {
                    Partner: ['Partner'],
                    Moneda: [],
                    CantidadTickets: ['CantidadTickets', 'sum'],
                },
            });
        });

        // Event listener for filtering data
        this.on(this.app, 'flujoCajaResumido:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add formatted start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add formatted end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
